import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFieldsCompact from '../../components/form/fieldsCompact';
import Input from '../../components/form/input';
import Versions from '../../components/versions';


@withText(props => ({
    orderNumber: <Text id='input.orderNumber-help'>orderNumber</Text>,
    name: <Text id='input.name-help'>name</Text>,
    description: <Text id='input.description-help'>description</Text>,
    installation: <Text id='input.installation-help'>installation</Text>,
    url: <Text id='input.url-help'>url</Text>,
}))
@observer
class NewCalendar extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('calendar'),
        };
    }

    loadAll = async () => {
        const { idx, id, isNew } = this.props;
        const { calendarStore } = this.props.stores;
        if (!isNew) {
            calendarStore.adminSetFromIdx(idx);
            // TODO: Do not overwrite calendarStore.calendar!
            if (id) {
                const idInt = parseInt(id, 10);
                const response = await calendarStore.adminLoad({ id: idInt }, { skipUpdate: true });
                const adminList = response?.data;
                const obj = adminList[0];
                calendarStore.updateKeyValue('calendar', obj);
            }
        }
    }

    createCalendar = async () => {
        const { callback = () => {} } = this.props;
        const { calendarStore } = this.props.stores;
        const { newCalendar } = calendarStore;
        const response = await calendarStore.adminCreate(newCalendar);
        if (response.status === 201) {
            callback();
        }
    }

    componentDidMount() {
        this.loadAll();
        // const { idx, isNew } = this.props;
        // const { calendarStore } = this.props.stores;
        // if (!isNew) {
        //     calendarStore.adminSetFromIdx(idx);
        // }
    }

    render() {
        const { week, isNew, drawerLevel } = this.props;
        const { sections } = this.state;
        const { userStore, calendarStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        const { newCalendar, calendar } = calendarStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>

                    <Versions stores={this.props.stores} type='calendar' id={calendar.id} key={`admin-calendar-${calendar.id}`} />

                    {/* <div class='w-100 d-flex flex-column justify-content-start'>
                        <xmp>{JSON.stringify(user.settings, null, 2)}</xmp>
                    </div> */}
                    {/* <xmp>{JSON.stringify(newCustomer, null, 4)}</xmp> */}
                    <h5 class='ms-3 mb-3'>
                        {isNew ? <Text id='calendar.new'>New calendar</Text> : <Text id='calendar.edit'>Edit calendar</Text>}
                    </h5>
                    <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                        <FormFieldsCompact stores={this.props.stores} sections={sections} holdingStore={calendarStore} objectName={isNew ? 'newCalendar' : 'calendar'} isNew={isNew} drawerLevel={drawerLevel} isAdmin={true} />
                    </div>
                    {isNew && <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style={`bottom: 0; left: 0;`}>
                        <button type='button' class='btn btn-primary rounded-pill' onClick={this.createCalendar}>
                            {isNew ? <Text id='calendar.create'>Create calendar</Text> : <Text id='calendar.save'>Save calendar</Text>}
                        </button>
                    </div>}
                </div>
            </div>
        </>);
    }
}

export default NewCalendar;
